<!-- 导航组件 -->
<template>
    <div class="v-nav">
        <div class="nav-tabs">
            <span class="nav-btn-tabs" :class="{'nav-tabs-active': ActiveTabs == 'sylx'}"
                @click="selectTabs('sylx')">事由类型</span>
            <span class="nav-tabs-line"></span>
            <span class="nav-btn-tabs" :class="{'nav-tabs-active': ActiveTabs == 'syly'}"
                @click="selectTabs('syly')">事由领域</span>
        </div>
        <Row class="nav-panel" :gutter="70" ref="nav-panel" v-if="loadDict">
            <!-- 事由类型 -->
            <template v-if="ActiveTabs == 'sylx'">
                <Col span="4" class="nav-btn-item" :class="{'nav-btn-active': ActiveType.length == 0}">
                <span @click="selectTypeItem">全部</span>
                </Col>
                <Col span="4" v-for="(item, index) in CauseTypeOption" :key="index" class="nav-btn-item"
                    :class="{'nav-btn-active': ActiveType.indexOf(item.excuteTypeName) != -1}">
                <span @click="selectTypeItem(item)">{{ item.excuteTypeName }}</span>
                </Col>
            </template>
            <!-- 事由领域 -->
            <template v-if="ActiveTabs == 'syly'">
                <Col span="4" class="nav-btn-item" :class="{'nav-btn-active': ActiveField.length == 0}">
                <span @click="selectFieldItem">全部</span>
                </Col>
                <Col span="4" v-for="(item, index) in CauseFieldOption" :key="index" class="nav-btn-item"
                    :class="{'nav-btn-active': ActiveField.indexOf(item.unitFuncTypeName) != -1}">
                <span @click="selectFieldItem(item)">{{ item.unitFuncTypeName }}</span>
                </Col>
            </template>
        </Row>
        <Row>
            <Col span="24" class="nav-btn-extend" ref="btn-extend">
            <div class="btn-open" v-if="CauseFieldOption.length > 0 && ActiveTabs == 'syly'">
                <span @click.stop="toggleNavPanel">
                    {{ this.IsOpen ? '收起' : '展开' }}
                    <i :class="this.IsOpen ? 'i-btn-close' : 'i-btn-open'"></i>
                </span>
            </div>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: 'VNav',
        components: {

        },
        props: {
            // 请求字典表结束后加装字典表
            loadDict: {
                type: Boolean,
                default() {
                    return false
                }
            },
            echoData: {
                type: Object,
                default() {
                    return {

                    }
                }
            }
        },
        data() {
            return {
                // 事由类型字典表
                CauseTypeOption: [],
                // 事由领域字典表
                CauseFieldOption: [],
                // 高亮的类型
                ActiveType: [],
                // 高亮的领域
                ActiveField: [],
                // 高亮的类型id
                CauseType: [],
                // 高亮的领域id
                FuncUnitType: [],
                ActiveTabs: 'sylx',
                IsOpen: false,
                cPanelHeight: '',
                // cPanelHeight: 352,

            }
        },
        computed: {

        },
        watch: {
            // 请求字典表结束后加装字典表
            loadDict: {
                handler(data) {
                    this.loadDict = data;
                    this.CauseTypeOption = this.$store.state.causeType;
                    this.CauseFieldOption = this.$store.state.causeField;
                },
            },
            // 字典长度变化，重新计算展开面板高度
            CauseFieldOption: {
                handler() {
                    this.cPanelHeight = this.CauseFieldOption.length > 0 ? Math.ceil(this.CauseFieldOption.length / 6) * 63 : 189;
                    let tempStyle = this.IsOpen ? 'height: ' + this.cPanelHeight + 'px' : 'height 189px';
                    if (this.$refs['nav-panel']) {
                        this.$refs['nav-panel'].$el.style = tempStyle;
                        // this.$refs['btn-extend'].$parent.$parent.$children[1].$el.style = tempStyle;
                    }
                },
            },
            // 字典长度变化，重新计算展开面板高度
            echoData: {
                handler(data) {
                    this.ActiveField = [];
                    this.FuncUnitType = [];
                    this.ActiveType = [];
                    this.CauseType = [];
                    // if (data.funcUnitType.length > 0) {
                    //   this.ActiveTabs = 'syly';
                    // } else {
                    //   this.ActiveTabs = 'sylx';
                    // }
                    // 领域数据回显
                    data.funcUnitType.forEach(item => {
                        this.ActiveField.push(item.unitFuncTypeName);
                        this.FuncUnitType.push(item.unitFuncTypeId);
                    });

                    // 事由数据回显
                    data.causeType.forEach(item => {
                        this.ActiveType.push(item.excuteTypeName);
                        this.CauseType.push(item.excuteTypeId);
                    });
                },
            }
        },
        created() {

        },
        mounted() {
            // this.CauseTypeOption = this.$store.state.causeType;
            // this.CauseFieldOption = this.$store.state.causeField;
        },
        destroyed() {

        },
        methods: {
            // 选中单个类型
            selectTypeItem(item) {
                // 不选全部时
                if (item.excuteTypeId) {
                    // 去除已选的
                    if (this.ActiveType.indexOf(item.excuteTypeName) != -1) {
                        this.ActiveType.splice(this.ActiveType.indexOf(item.excuteTypeName), 1);
                        this.CauseType.splice(this.CauseType.indexOf(item.excuteTypeId), 1);
                    } else {
                        this.ActiveType.push(item.excuteTypeName);
                        this.CauseType.push(item.excuteTypeId);
                    }
                } else {
                    // 选全部时清空
                    this.ActiveType = [];
                    this.CauseType = [];
                }

                let causeType = [];
                let funcUnitType = [];
                this.CauseTypeOption.forEach(v => {
                    this.CauseType.forEach(ele => {
                        if (ele == v.excuteTypeId) {
                            causeType.push(v);
                        }
                    });
                });

                // 回传数据到父组件
                this.$emit('emitNav', {
                    causeType: this.CauseType,
                    funcUnitType: []
                }, { causeType, funcUnitType });

            },
            // 选中单个领域
            selectFieldItem(item) {
                // 不选全部时
                if (item.unitFuncTypeId) {
                    // 去除已选的
                    if (this.ActiveField.indexOf(item.unitFuncTypeName) != -1) {
                        this.ActiveField.splice(this.ActiveField.indexOf(item.unitFuncTypeName), 1);
                        this.FuncUnitType.splice(this.FuncUnitType.indexOf(item.unitFuncTypeId), 1);
                    } else {
                        this.ActiveField.push(item.unitFuncTypeName);
                        this.FuncUnitType.push(item.unitFuncTypeId);
                    }
                } else {
                    // 选全部时清空
                    this.ActiveField = [];
                    this.FuncUnitType = [];
                }

                let causeType = [];
                let funcUnitType = [];
                this.CauseFieldOption.forEach(v => {
                    this.FuncUnitType.forEach(ele => {
                        if (ele == v.unitFuncTypeId) {
                            funcUnitType.push(v);
                        }
                    });
                });

                // 回传数据到父组件
                this.$emit('emitNav', {
                    causeType: [],
                    funcUnitType: this.FuncUnitType
                }, { causeType, funcUnitType });
            },

            // 选中类型分类或者领域分类
            selectTabs(value) {
                this.ActiveTabs = value;
                this.IsOpen = false;
                if (value == 'syly') {
                  this.$refs['nav-panel'].$el.style.height = '189px';
                } else {
                  this.$refs['nav-panel'].$el.style.height = 'auto';
                }

                let causeType = [];
                let funcUnitType = [];
                this.$emit('emitNav', {
                    causeType: [],
                    funcUnitType: []
                }, { causeType, funcUnitType });
            },

            // 展开面板，查看全部职权部门
            toggleNavPanel() {
                this.IsOpen = !this.IsOpen;
                let tempStyle = this.IsOpen ? 'height: ' + this.cPanelHeight + 'px' : 'height: 189px';
                this.$refs['nav-panel'].$el.style = tempStyle;
            }
        }
    }
</script>

<style scoped>
    .nav-tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0;
    }

    .nav-btn-tabs {
        padding: 8px 24px;
        border: 1px solid #c9c9c9;
        border-radius: 3px;
        color: #1867dd;
        cursor: pointer;
    }

    .nav-tabs-line {
        margin: 0 32px;
        width: 1px;
        height: 36px;
        background-color: #999;
    }

    .nav-btn-tabs:hover {
        border: 1px solid #1867DD;
        color: #fff;
        background-color: #1867DD;
    }

    .nav-tabs-active {
        border: 1px solid #1867DD;
        color: #fff;
        background-color: #1867DD;
    }

    .nav-panel {
        overflow: hidden;
        margin: 0 !important;
        padding: 0;
        /* height: 189px; */
        transition: height 0.6s ease;
    }

    .nav-btn-item {
        padding: 0 15px !important;
        margin-bottom: 18px;
        color: #333333;
    }

    .nav-btn-item span {
        float: left;
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        color: #333333;
        border: 1px solid #efefef;
        border-radius: 3px;
        background-color: #fff;
        box-shadow: 0 2px 4px 0 #efefef;
        cursor: pointer;
    }

    .nav-btn-item:hover span {
        color: #fff;
        border: 1px solid #1867DD;
        border-radius: 3px;
        background-color: #1867DD;
        cursor: pointer;
        transition: all 0.3s;
    }

    .nav-btn-active span {
        color: #fff;
        border: 1px solid #1867DD;
        border-radius: 3px;
        background-color: #1867DD;
        cursor: pointer;
    }

    .nav-btn-extend {
        margin: 18px 0;
    }

    .btn-open span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999999;
        cursor: pointer;
    }

    .btn-open i {
        margin: -1px 0 0 6px;
        width: 14px;
        height: 14px;
        transform: scale(0.7);
        cursor: pointer;
    }

    .i-btn-open {
        background: url(../../assets/img/icon-more.png) 0 0 no-repeat;
    }

    .i-btn-close {
        background: url(../../assets/img/icon-close.png) 0 0 no-repeat;
    }
</style>